export default __webpack_public_path__ + "src/assets/Google_Ad_Manager_logo.jpg";